import { type ISourceOptions } from "@tsparticles/engine";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import React from "react";
import { loadFull } from "tsparticles";

const options: ISourceOptions = {
  particles: {
    color: {
      value: "#E1EBFA",
    },
    life: {
      count: 1,
    },
    move: {
      direction: "bottom-right",
      enable: true,
      random: false,
      straight: false,
      speed: 0,
    },
    number: {
      value: 45,
    },
    shape: {
      type: "image",
      options: {
        image: {
          src: "assets/cross-soft-blue.png",
        },
      },
    },
    opacity: {
      value: {
        min: 0.1,
        max: 0.4,
      },
    },
    size: {
      animation: {
        enable: true,
        sync: false,
      },
      value: {
        min: 1,
        max: 10,
      },
    },
    wobble: {
      distance: 10,
      enable: true,
      speed: {
        min: -5,
        max: 5,
      },
    },
  },
  detectRetina: true,
};

const AuthParticles = () => {
  const [init, setInit] = React.useState(false);

  React.useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  if (!init) {
    return <></>;
  }

  return <Particles options={options} />;
};

export default AuthParticles;
